import PricingPackagingContextProvider from 'contexts/PricingPackagingContextProvider';

import BundleList from '../../components/BundleList';
import BundleListCollapsable from '../../components/BundleListCollapsable';
import {
  PACKAGE_PRICES_MONTHLY,
  PACKAGE_PRICES_YEARLY,
  PACKAGE_TOPHIGHLIGHTS,
  YEARLY_TERM,
} from '../../constants';

import { SelectPlanBundleCards } from './SelectPlanBundleCards';
import { SelectPlanPriceTermSwitcher } from './SelectPlanPriceTermSwitcher';

export const SelectPlanCardsAndList = ({
  canChoosePlan = false,
  collapsableListButtonLabel = 'Compare plans and features',
  commonBundleCardProps = {},
  currentPlan,
  displayCollapsableDesktopList = false,
  displayPrice = true,
  handleTabChange,
  isMobileView,
  monthlyPackagePrices = PACKAGE_PRICES_MONTHLY,
  onBundleCardCtaOnClick,
  onToggleFeatureList,
  priceTerm = YEARLY_TERM,
  topHighlightsPackages = PACKAGE_TOPHIGHLIGHTS,
  yearlyPackagePrices = PACKAGE_PRICES_YEARLY,
}) => (
  <PricingPackagingContextProvider
    canChoosePlan={canChoosePlan}
    commonBundleCardProps={commonBundleCardProps}
    currentPlan={currentPlan}
    displayPrice={displayPrice}
    isMobileView={isMobileView}
    monthlyPackagePrice={monthlyPackagePrices}
    onBundleCardCtaOnClick={onBundleCardCtaOnClick}
    onToggleFeatureList={onToggleFeatureList}
    priceTerm={priceTerm}
    topHighlightsPackages={topHighlightsPackages}
    yearlyPackagePrices={yearlyPackagePrices}
  >
    {handleTabChange && (
      <SelectPlanPriceTermSwitcher
        handleTabChange={handleTabChange}
        my={8}
        tabIndex={priceTerm === YEARLY_TERM ? 0 : 1}
        yearlyTabName="Save yearly"
      />
    )}

    <SelectPlanBundleCards />

    {isMobileView ? null : displayCollapsableDesktopList ? (
      <BundleListCollapsable
        buttonLabel={collapsableListButtonLabel}
        {...commonBundleCardProps}
      />
    ) : (
      <BundleList />
    )}
  </PricingPackagingContextProvider>
);
